<template>
  <div
    class="preview"
    :class="[computedCharacterColorClass]"
  >
    <component
      v-if="true"
      :is="computedComponentName"
      :class="[computedCharacterColorClass]"
    />
  </div>
</template>

<script>
// 通常位牌 1霊
import N1East from "@/components/Common/TabletPreview/Items/ColorSamples/N1East/Front.vue";
import N1West from "@/components/Common/TabletPreview/Items/ColorSamples/N1West/Front.vue";
// 通常位牌 2霊
import N2East from "@/components/Common/TabletPreview/Items/ColorSamples/N2East/Front.vue";
import N2East2 from "@/components/Common/TabletPreview/Items/ColorSamples/N2East2/Front.vue";
import N2East3 from "@/components/Common/TabletPreview/Items/ColorSamples/N2East3/Front.vue";
import N2West from "@/components/Common/TabletPreview/Items/ColorSamples/N2West/Front.vue";
import N2West2 from "@/components/Common/TabletPreview/Items/ColorSamples/N2West2/Front.vue";
import N2West3 from "@/components/Common/TabletPreview/Items/ColorSamples/N2West3/Front.vue";
// 俗名位牌 1霊
import S1East from "@/components/Common/TabletPreview/Items/ColorSamples/S1East/Front.vue";
import S1West from "@/components/Common/TabletPreview/Items/ColorSamples/S1West/Front.vue";
// マインドアルテ 1霊
import M1A from "@/components/Common/TabletPreview/Items/ColorSamples/M1A/Front.vue";
import M1B from "@/components/Common/TabletPreview/Items/ColorSamples/M1B/Front.vue";
// マインドアルテ 2霊
import M2 from "@/components/Common/TabletPreview/Items/ColorSamples/M2/Front.vue";

// Mixins
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.component,
    TabletPreviewMixin.character,
  ],
  components: {
    N1East,
    N1West,
    N2East,
    N2East2,
    N2East3,
    N2West,
    N2West2,
    N2West3,
    S1East,
    S1West,
    M1A,
    M1B,
    M2,
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-common.scss";
</style>
